// extracted by mini-css-extract-plugin
module.exports = {"metrics-container":"MetricsWidget_metrics-container__1fUh5","metric":"MetricsWidget_metric__2-nfl","with-tooltip":"MetricsWidget_with-tooltip__2zv4U"};